import {Button, message, Popconfirm, Alert} from "antd";
import dayjs from "dayjs";
import api from "../../api";
import {ArrowRightOutlined} from "@ant-design/icons";
import React, {useState, useEffect} from "react";
import './style.css'
import {useTranslations} from "../../lang";
import {formatPlanPrice} from "../../helpers";

export default function PlanBox({isActive, plan, company}) {
    const {translate} = useTranslations()
    const [subscriptionStatus, setSubscriptionStatus] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        if (isActive) {
            api.getSubscriptionStatus().then(setSubscriptionStatus).catch(() => {
                // Silently fail if endpoint not available
            })
        }
    }, [isActive])

    const handleCancelSubscription = async () => {
        setLoading(true)
        try {
            const result = await api.cancelSubscription()
            message.success(result.message || translate('Automatische verlenging geannuleerd'))
            setSubscriptionStatus({...subscriptionStatus, is_subscription_active: false})
        } catch (error) {
            message.error(translate('Er is iets misgegaan'))
        }
        setLoading(false)
    }

    const handleReactivateSubscription = async () => {
        setLoading(true)
        try {
            const result = await api.reactivateSubscription()
            message.success(result.message || translate('Automatische verlenging geactiveerd'))
            setSubscriptionStatus({...subscriptionStatus, is_subscription_active: true})
        } catch (error) {
            message.error(error.response?.data?.message || translate('Er is iets misgegaan'))
        }
        setLoading(false)
    }

    return (
        <div className={(isActive) ? "plan-box active-plan" : "plan-box"}>
            <h2>{plan.name}</h2>
            {plan.price > 0 && (
                <>
                    <h3>{formatPlanPrice(plan.price, plan.currency)} {translate('per jaar')}</h3>
                </>
            )}
            {plan.price === 0 && (
                <h3>{translate('Voor altijd gratis!')}</h3>
            )}
            {plan.price === -1 && (
                <h3>{translate('Vraag offerte aan')}</h3>
            )}
            {plan.currency === 'USD' ? (
                <p>{translate('Totaal weergegeven in USD')}</p>
            ) : (
                <p>{translate('Inclusief 21% BTW')}</p>
            )}

            <ul className={"plan-features"}>
                <li>{translate('Onbeperkt aantal tuinen')}</li>
                <li> {translate('Onbeperkt aantal bedden per tuin')}</li>

                {(plan.crop_limit && plan.crop_limit > 0) ? (
                    <li>
                        <b>{translate('Maximaal')} {plan.crop_limit}</b> {translate('gewassen')}
                    </li>
                ) : (
                    <li>
                        <b>{translate('Onbeperkt aantal')}</b> {translate('gewassen')}
                    </li>
                )}
                <li>{translate('Rij en plantafstand calculator')}</li>
                <li>{translate('Zaai, verplant en oogsttijden calculator')}</li>
                {(plan.has_plukkers) && (
                    <li>{translate('Koppeling met')} Plukkers.com</li>
                )}
                {(plan.has_bolster) && (
                    <li>{translate('Koppeling met')} Bolster.nl</li>
                )}

                {(plan.has_team) && (
                    <li>{translate('Manage je teamleden en hun taken')}</li>
                )}
            </ul>

            {(isActive && company) && (
                <>
                    <Button size={"large"} disabled>{translate('Je huidige pakket')}</Button>
                    {(company.plan_expires_at && (
                        <p className={"mar-t-1"}>
                            {translate('Je account verloopt op')}:<br/>
                            {dayjs(company.plan_expires_at).format("dddd D MMMM YYYY")}
                        </p>
                    ))}

                    {subscriptionStatus && subscriptionStatus.has_mandate && (
                        <div className={"mar-t-1 mar-b-1"}>
                            {subscriptionStatus.is_subscription_active ? (
                                <Alert
                                    message={translate('Automatische verlenging actief')}
                                    description={translate('Je account wordt automatisch verlengd wanneer deze verloopt.')}
                                    type="success"
                                    showIcon
                                />
                            ) : (
                                <Alert
                                    message={translate('Automatische verlenging uit')}
                                    description={translate('Je account wordt niet automatisch verlengd.')}
                                    type="warning"
                                    showIcon
                                />
                            )}
                        </div>
                    )}

                    {(plan.price > 0 && (
                            <Button className={"mar-b-1"} type={"primary"} block onClick={() => {
                                api.upgradePlan(plan.id).then(({url}) => {
                                    document.location = url
                                })
                            }}>{translate('Met 1 jaar verlengen')}</Button>)
                    )}

                    {subscriptionStatus && subscriptionStatus.has_mandate && subscriptionStatus.is_subscription_active && (
                        <Popconfirm
                            title={translate('Automatische verlenging annuleren')}
                            description={translate('Je account blijft actief tot de vervaldatum, maar wordt niet automatisch verlengd.')}
                            onConfirm={handleCancelSubscription}
                            okText={translate('Ja, annuleren')}
                            cancelText={translate('Nee, behouden')}
                        >
                            <Button danger block loading={loading}>
                                {translate('Automatische verlenging annuleren')}
                            </Button>
                        </Popconfirm>
                    )}

                    {subscriptionStatus && subscriptionStatus.has_mandate && !subscriptionStatus.is_subscription_active && (
                        <Button type={"primary"} block loading={loading} onClick={handleReactivateSubscription}>
                            {translate('Automatische verlenging activeren')}
                        </Button>
                    )}
                </>
            )}
            {(!isActive && plan.price > 0) && (
                <>
                    <Button type={"primary"} size={"large"} href={`/pay/${plan.id}`}>
                        {translate('Selecteer pakket')} <ArrowRightOutlined/>
                    </Button>

                    <p className={"text-center mar-t-1"}>{translate('Niet goed? Geld terug!')}</p>
                </>
            )}
            {(!isActive && plan.price === 0) && (
                <Button type={"primary"} size={"large"} href={"/register"}>
                    {translate('Start nu gratis')}
                </Button>
            )}

        </div>
    )
}